import type { Data } from '../../types';

export enum NoProps {
  'NO_PROPS'
}

export type Props = {
  data: Data | NoProps;
};
